import { Action } from 'redux';
import {
  CLEAR_AUTH_REQUEST_FAILURE,
  FAIL_AUTH_REQUEST,
  RECEIVE_AUTH_REQUEST,
  SEND_AUTH_REQUEST,
  SET_AUTH_CODE,
  SET_AUTH_CODE_STATUS,
  SET_INPUT_FOCUSED,
  SET_INPUT_STATUS,
  SET_IS_AUTH_RESTART_REQUIRED,
  SET_IS_USER_IN_PHILO_SUPPORTED_GEO_REGION,
  SET_SHOULD_REQUEST_NEW_AUTH_CODE,
  SET_USER_LOCATION,
} from '../actions/auth';
import { SET_AUTH_MESSAGE } from '../actions/common';
import DEFAULT_STATE, { AuthState } from '../defaults/auth';
import createReducer from './create-reducer';

type Payload<T extends keyof AuthState = keyof AuthState> = Pick<AuthState, T>;

function sendAuthRequest(state: AuthState) {
  return {
    ...state,
    isSendingAuthRequest: true,
  };
}

function receiveAuthRequest(state: AuthState) {
  return {
    ...state,
    isSendingAuthRequest: false,
  };
}

function failAuthRequest(state: AuthState, { message, errorCode }: Payload) {
  return {
    ...state,
    isAuthRequestFailed: true,
    message,
    errorCode,
  };
}

function clearAuthRequestFailure(state: Payload) {
  return {
    ...state,
    isAuthRequestFailed: false,
    message: '',
    errorCode: null,
  };
}

function setAuthMessage(state: AuthState, { message }: Payload<'message'>) {
  return {
    ...state,
    message,
    errorCode: null,
  };
}

function setIsAuthRestartRequired(
  state: AuthState,
  { isAuthRestartRequired }: Payload<'isAuthRestartRequired'>,
) {
  return {
    ...state,
    isAuthRestartRequired,
  };
}

function setIsUserInPhiloSupportedGeoRegion(
  state: AuthState,
  { isUserInPhiloSupportedGeoRegion }: Payload<'isUserInPhiloSupportedGeoRegion'>,
) {
  return {
    ...state,
    isUserInPhiloSupportedGeoRegion,
  };
}

function setUserLocation(state: AuthState, { location }: Payload<'location'>) {
  return {
    ...state,
    location,
  };
}

function setInputStatus(state: AuthState, { inputStatus }: Payload<'inputStatus'>) {
  return {
    ...state,
    inputStatus,
  };
}

function setInputFocused(state: AuthState, { inputFocused }: Payload<'inputFocused'>) {
  return {
    ...state,
    inputFocused,
  };
}

function updateAuth(state: AuthState, { type, ...payload }: Action & Payload) {
  return {
    ...state,
    ...payload,
  };
}

const handlers = {
  [SEND_AUTH_REQUEST]: sendAuthRequest,
  [RECEIVE_AUTH_REQUEST]: receiveAuthRequest,
  [FAIL_AUTH_REQUEST]: failAuthRequest,
  [CLEAR_AUTH_REQUEST_FAILURE]: clearAuthRequestFailure,
  [SET_AUTH_MESSAGE]: setAuthMessage,
  [SET_IS_AUTH_RESTART_REQUIRED]: setIsAuthRestartRequired,
  [SET_IS_USER_IN_PHILO_SUPPORTED_GEO_REGION]: setIsUserInPhiloSupportedGeoRegion,
  [SET_USER_LOCATION]: setUserLocation,
  [SET_INPUT_STATUS]: setInputStatus,
  [SET_INPUT_FOCUSED]: setInputFocused,
  [SET_AUTH_CODE]: updateAuth,
  [SET_AUTH_CODE_STATUS]: updateAuth,
  [SET_SHOULD_REQUEST_NEW_AUTH_CODE]: updateAuth,
};

export default createReducer(DEFAULT_STATE, handlers);
